import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import * as moment from 'moment';
var Tipo_proyectoComponent = /** @class */ (function () {
    function Tipo_proyectoComponent() {
        this.rows = [];
        this.matcher = new FormService();
        this.maxDate = moment().toDate();
        this.form = new FormGroup({
            tipo_proy1: new FormControl(''),
            tipo_proy2: new FormControl(''),
            tipo_proy3: new FormControl(''),
            tipo_proy4: new FormControl(''),
            tipo_proy5: new FormControl(''),
            tipo_proy6: new FormControl(''),
            perm_recep: new FormControl(''),
            perm_numero: new FormControl(''),
            perm_fecha: new FormControl({ value: '', disabled: true }),
            perm_sup: new FormControl(''),
            mod_proy_res: new FormControl(''),
            mod_proy_fech: new FormControl({ value: '', disabled: true }),
            rparcial_proy_res: new FormControl(''),
            sup_proy_res: new FormControl(''),
            dest_proy_res: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("tipo_proyecto"))) {
            localStorage.setItem("tipo_proyecto", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("tipo_proyecto"));
            this.form.controls['tipo_proy1'].setValue(this.rows[0] ? this.rows[0].condominio_tipoA : false);
            this.form.controls['tipo_proy2'].setValue(this.rows[0] ? this.rows[0].condominio_tipoB : false);
            this.form.controls['tipo_proy3'].setValue(this.rows[0] ? this.rows[0].edificaciones_loteo : false);
            this.form.controls['tipo_proy4'].setValue(this.rows[0] ? this.rows[0].urbanizacion_recibida : false);
            this.form.controls['tipo_proy5'].setValue(this.rows[0] ? this.rows[0].urbanizacion_garantizada : false);
            this.form.controls['tipo_proy6'].setValue(this.rows[0] ? this.rows[0].recepcion_urbanizacion : false);
            this.form.controls['perm_recep'].setValue(this.rows[0] ? this.rows[0].perm_recep : '');
            this.form.controls['perm_numero'].setValue(this.rows[0] ? this.rows[0].perm_numero : '');
            this.form.controls['perm_fecha'].setValue(this.rows[0] ? this.rows[0].perm_fecha : false);
            this.form.controls['perm_sup'].setValue(this.rows[0] ? this.rows[0].perm_sup : '');
            this.form.controls['mod_proy_res'].setValue(this.rows[0] ? this.rows[0].mod_proy_res : '');
            this.form.controls['mod_proy_fech'].setValue(this.rows[0] ? this.rows[0].mod_proy_fech : '');
            this.form.controls['rparcial_proy_res'].setValue(this.rows[0] ? this.rows[0].rparcial_proy_res : false);
            this.form.controls['sup_proy_res'].setValue(this.rows[0] ? this.rows[0].sup_proy_res : '');
            this.form.controls['dest_proy_res'].setValue(this.rows[0] ? this.rows[0].dest_proy_res : '');
        }
        this.tipo_proyecto = { condominio_tipoA: '', condominio_tipoB: '', edificaciones_loteo: '', urbanizacion_recibida: '', urbanizacion_garantizada: '', recepcion_urbanizacion: '', perm_recep: '', perm_numero: '', perm_fecha: '', perm_sup: '', mod_proy_res: '', mod_proy_fech: '', rparcial_proy_res: '', sup_proy_res: '', dest_proy_res: '' };
        if (localStorage.getItem("form")) {
            this.numberForm = localStorage.getItem("form");
            if (this.numberForm == '2.5') {
                this.encontrado = true;
            }
        }
    }
    Tipo_proyectoComponent.prototype.add_tipo_proyecto = function (event, type) {
        if (event) {
            this.perm_fecha = moment(event.value).format('DD/MM/YYYY');
            this.mod_proy_fech = moment(event.value).format('DD/MM/YYYY');
        }
        else {
            var temp = JSON.parse(localStorage.getItem("tipo_proyecto"));
            if (temp > 0) {
                this.perm_fecha = temp[0].perm_fecha;
                this.mod_proy_fech = temp[0].mod_proy_fech;
            }
            else {
                this.perm_fecha = '';
                this.mod_proy_fech = '';
            }
        }
        localStorage.setItem("tipo_proyecto", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_proyecto");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            'condominio_tipoA': this.form.value.tipo_proy1,
            'condominio_tipoB': this.form.value.tipo_proy2,
            'edificaciones_loteo': this.form.value.tipo_proy3,
            'urbanizacion_recibida': this.form.value.tipo_proy4,
            'urbanizacion_garantizada': this.form.value.tipo_proy5,
            'recepcion_urbanizacion': this.form.value.tipo_proy6,
            perm_recep: this.form.value.perm_recep,
            perm_numero: this.form.value.perm_numero,
            perm_fecha: moment(this.form.value.perm_fecha).format("DD/MM/YYYY"),
            perm_sup: this.form.value.perm_sup,
            mod_proy_res: this.form.value.mod_proy_res,
            mod_proy_fech: moment(this.form.value.mod_proy_fech).format("DD/MM/YYYY"),
            rparcial_proy_res: this.form.value.rparcial_proy_res,
            sup_proy_res: this.form.value.sup_proy_res,
            dest_proy_res: this.form.value.dest_proy_res
        });
        localStorage.setItem("tipo_proyecto", JSON.stringify(this.rows));
    };
    Tipo_proyectoComponent.prototype.delete_tipo_proyecto = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_proyecto", JSON.stringify(this.rows));
            }
        }
    };
    return Tipo_proyectoComponent;
}());
export { Tipo_proyectoComponent };
